<section class="absolute mt-2 mb-20 ml-2 z-10" [ngClass]="{ 'max-h-[75vh] flex flex-col': isPositions, 'w-2xl': !collapsed, 'w-fit': collapsed }">
    <!--article class="header flex h-16 w-[32.688rem] bg-primary-green-2 items-center rounded-t-lg">
        <div class="cursor-pointer" (click)="goBack()">
            @if (showTripDetails) {
                <img [src]="images.arrowLeft" class="h-6 w-6 ml-4" />
            }
        </div>
        <h1 class="text-[22px] font-bold" [ngClass]="{'ml-4': !showTripDetails, 'ml-2': showTripDetails}">{{ literalService.get('trips.name', true) }}</h1>
    </article-->

        <article class="flex justify-start bg-primary-green-2 items-center p-4 gap-8" [ngClass]="{'hidden': showTripDetails}">
            <app-trip-search-bar
            [placeholder]="literalService.get('trips.search', true)"
            [searching]="searching"
            [searchValue]="searchValue"
            [viewMode]="viewMode"
            [collapsed]="collapsed"
            (filter)="filter($event)"
            (searchEventEmitter)="search($event)"
            (viewModeChange)="viewModeChange.emit($event)"
          ></app-trip-search-bar>
          @if (collapsed) {
            <button type="button" class="btn btn-ghost btn-sm rounded! bg-neutrals-white border-neutrals-grey-02! px-2!" (click)="expanded = true" [tooltip]="literalService.get('trips.positions.expand', true)" [position]="TooltipPosition.ABOVE">
                <img [src]="images.expandInFull" alt="contract" class="h-5 w-5" />
            </button>
          }
        </article>
    @if (!showTripDetails && !collapsed) {
        <article class="bg-white rounded-b-lg p-4 pb-14" [ngClass]="{ 'min-h-0 flex flex-col pb-4!': isPositions }">
            <div class="grid grid-cols-11 mx-2 mb-4 text-center">
                <div class="flex justify-center items-center col-span-1">
                  <app-column-filter
                    [id]="'tripsServicesFilter'"
                    [icon]="images.sidebar.services"
                    [label]="literalService.get('vehicles.filters.services', true)"
                    [loader]="serviceLoader"
                    [loadById]="serviceByIdLoader"
                    [toOption]="serviceOption"
                    [selected]="servicesSelected"
                    (apply)="onServicesFilter($event)"
                  />
                </div>
                <div class="flex justify-center items-center col-span-3">
                  <app-column-filter
                    [id]="'tripsRoutesFilter'"
                    [icon]="images.route"
                    [label]="literalService.get('vehicles.filters.routes', true)"
                    [loader]="routeLoader"
                    [loadById]="routeByIdLoader"
                    [toOption]="routeOption"
                    [selected]="routesSelected"
                    [disabled]="servicesSelected.length === 0"
                    [disabledTooltip]="servicesSelected.length === 0 ? literalService.get('trips.tooltips.routeFilterRequiresService', true) : ''"
                    (apply)="onColumnFilter({ selectedRoutes: $event })"
                  />
                </div>
                <label class="flex justify-center items-center col-span-1">
                    <img [src]="images.trips.date" alt="date" class="h-6 w-6" />
                </label>
                <div class="flex justify-center items-center col-span-2">
                  <app-column-filter
                    [id]="'tripsDriversFilter'"
                    [icon]="images.trips.driver"
                    [label]="literalService.get('vehicles.filters.drivers', true)"
                    [loader]="driverLoader"
                    [loadById]="driverByIdLoader"
                    [toOption]="driverOption"
                    [selected]="driversSelected"
                    (apply)="onColumnFilter({ selectedDrivers: $event })"
                  />
                </div>
                <div class="flex justify-center items-center col-span-2">
                  <app-column-filter
                    [id]="'tripsVehiclesFilter'"
                    [icon]="images.trips.vehicle"
                    [label]="literalService.get('vehicles.filters.vehicles', true)"
                    [loader]="vehicleLoader"
                    [loadById]="vehicleByIdLoader"
                    [toOption]="vehicleOption"
                    [selected]="vehiclesSelected"
                    (apply)="onColumnFilter({ selectedVehicles: $event })"
                  />
                </div>
                <label class="flex justify-center items-center col-span-2">
                    <img [src]="images.moreOptions" alt="moreOptions" class="h-6 w-6" />
                </label>
            </div>
            <div [ngClass]="{ 'min-h-0 overflow-auto': isPositions }">
            @if (!trips.isFetchingTrips) {
                @for (trip of trips.value; track $index) {
                    <app-trip-row [trip]="trip"
                                class="block"
                                [dimmed]="isPositions && tripsWithoutMarker()[trip.id!]"
                                [followsPositions]="isPositions"
                                [positionsDelay]="positionsDelays()[trip.id!]"
                                [basePath]="basePath"
                                [language]="language"
                                [index]="$index"
                                (getTripEventEmitter)="getTripDetails($event)"
                                (showChangeDriverEventEmitter)="showChangeDriverEventEmitter.emit($event)"
                                (showChangeVehicleEventEmitter)="showChangeVehicleEventEmitter.emit($event)"
                                (showEditCommentEventEmitter)="showEditCommentEventEmitter.emit($event)"
                                (showViewBookingsEventEmitter)="showViewBookingsEventEmitter.emit($event)"
                                (showSetReadyEventEmitter)="showSetReadyEventEmitter.emit($event)"
                                (showSetClosedEventEmitter)="showSetClosedEventEmitter.emit($event)"
                                (showDeleteTripEventEmitter)="showDeleteTripEventEmitter.emit($event)"
                                [activeTickets]="trips.activeTicketsByExpedition[trip.id!] ?? []"
                                (newTicketEventEmitter)="newTicketEventEmitter.emit($event)"/>
                }
            } @else {
                <ngx-skeleton-loader [count]="trips.pagination.numberOfElements || pageSize" appearance="line" [theme]="{ 'height': '60px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
            }
            </div>
            @if (trips.value.length > 0 || trips.isFetchingTrips || isPositions) {
                <div class="mt-6 flex items-center justify-end gap-2">
                    @if (trips.value.length > 0 || trips.isFetchingTrips) {
                        <app-pagination [pagination]="trips.pagination" [right]="true" [inline]="isPositions" [loading]="trips.isFetchingTrips && !trips.pagination.totalPages" [baseUrl]="basePath" (changePage)="changePage($event)" />
                    }
                    @if (isPositions) {
                        <button type="button" class="btn btn-ghost btn-sm rounded! border-neutrals-grey-02! px-2!" (click)="expanded = false" [tooltip]="literalService.get('trips.positions.contract', true)" [position]="TooltipPosition.ABOVE">
                            <img [src]="images.closeInFull" alt="contract" class="h-5 w-5" />
                        </button>
                    }
                </div>
            }
        </article>
    } @else if (tripDetails && !collapsed) {
        <div class="p-4 bg-white relative flex flex-col" [ngClass]="isPositions ? 'min-h-0' : 'max-h-[calc(100vh-7rem)]'">
            <article class="pb-1">
                <app-trip-row [trip]="selectedTrip"
                [followsPositions]="isPositions"
                [positionsDelay]="positionsDelays()[selectedTrip.id!]"
                [basePath]="basePath"
                [language]="language"
                [tripDetails]="!!tripDetails"
                (getTripEventEmitter)="getTripDetails($event)"
                (showChangeDriverEventEmitter)="showChangeDriverEventEmitter.emit($event)"
                (showChangeVehicleEventEmitter)="showChangeVehicleEventEmitter.emit($event)"
                (showEditCommentEventEmitter)="showEditCommentEventEmitter.emit($event)"
                (showViewBookingsEventEmitter)="showViewBookingsEventEmitter.emit($event)"
                (showSetReadyEventEmitter)="showSetReadyEventEmitter.emit($event)"
                (showSetClosedEventEmitter)="showSetClosedEventEmitter.emit($event)"
                (showDeleteTripEventEmitter)="showDeleteTripEventEmitter.emit($event)"
                (newTicketEventEmitter)="newTicketEventEmitter.emit($event)"/>
            </article>
            <article class="pb-2">
                <div class="flex items-center w-full">
                    <label class="w-27.5 shrink-0 text-center font-semibold text-base" [tooltip]="literalService.get('trips.tooltips.arrivalDeparture', true)" [position]="TooltipPosition.BELOW">{{ literalService.get('trips.arrivalDeparture') }}</label>
                    <div class="flex bg-neutrals-grey-01 justify-between items-center flex-1 ml-4 py-1 px-4 rounded">
                        <div class="flex" [tooltip]="literalService.get('trips.tooltips.totalDistance', true)" [position]="TooltipPosition.BELOW">
                            <img [src]="images.distanceBooking" class="h-6 w-6" />
                            <label class="ml-1 mr-4 font-semibold text-base">{{ (tripDetails.distance | number:'1.0-2') || 0 }} km</label>
                        </div>
                        <div class="flex" [tooltip]="literalService.get('trips.tooltips.meanVelocity', true)" [position]="TooltipPosition.BELOW">
                            <img [src]="images.speed" class="h-6 w-6" />    
                            <label class="ml-1 mr-4 font-semibold text-base">{{ tripDetails.velocity || 0 }} km/h</label>
                        </div>
                        <div class="flex" [tooltip]="literalService.get('trips.tooltips.variationTime', true)" [position]="TooltipPosition.BELOW">
                            <img [src]="images.clock" class="h-6 w-6"/>
                            <label class="ml-1 mr-4 font-semibold text-base"
                              [class.text-secondary-green]="selectedTrip.status === expeditionStatus.ONGOING && !utilsService.isLate(selectedTrip.delay)"
                              [class.text-secondary-red]="selectedTrip.status === expeditionStatus.ONGOING && utilsService.isLate(selectedTrip.delay)">{{ utilsService.displayedDelay(tripDetails.delay) }} min</label>
                        </div>
                        <div class="flex items-center">
                            <div class="flex" [tooltip]="literalService.get('trips.tooltips.passengersOnBoard', true)" [position]="TooltipPosition.BELOW">
                                <img [src]="images.pax" class="h-6 w-6"/>
                                <label class="ml-1 mr-2 font-semibold text-base">{{ tripDetails.occupancy || 0 }}  /  {{ tripDetails.totalPax || 0 }} pax</label>
                            </div>
                            <!-- TODO: Uncomment this when we use me/permissions  -->
                            <!-- <img [src]="images.plus" class="h-5 w-5 cursor-pointer" (click)="showAddPaxEventEmitter.emit(selectedTrip.id)" data-modal-target="addPax" data-modal-toggle="addPax" [tooltip]="literalService.get('trips.actions.addPax.name', true)" [position]="TooltipPosition.ABOVE" [hidden]="!roleService.permissions['EXPEDITION']['UPDATE']"/> -->
                            <img [src]="images.plus" class="h-5 w-5 cursor-pointer" (click)="showAddPaxEventEmitter.emit(selectedTrip.id)" [tooltip]="literalService.get('trips.actions.addPax.name', true)" [position]="TooltipPosition.ABOVE" />
                        </div>
                    </div>
                </div>
            </article>
            <article class="pt-4 overflow-auto" [ngClass]="isPositions ? 'min-h-0 flex-1' : 'max-h-[calc(100vh-18rem)]'">
                <div class="flex">
                    <div class="mr-4">
                        @for (stop of tripDetails.stops; track $index) {
                            @let arrival = getStopTime(stop, false);
                            @let departure = getStopTime(stop, true);
                            <article class="flex bg-neutrals-grey-01 w-27.5 rounded ps-2 pe-2 pt-2 pb-2 mb-10 justify-center">
                                <label class="text-base" [ngClass]="arrival.styleClass" [tooltip]="arrival.tooltip" [position]="TooltipPosition.BELOW">{{ arrival.value }}</label>
                                <article class="w-px bg-neutrals-grey-03 mr-2 ml-2"></article>
                                <label class="text-base" [ngClass]="departure.styleClass" [tooltip]="departure.tooltip" [position]="TooltipPosition.BELOW">{{ departure.value }}</label>
                            </article>
                        }
                    </div>
                    <div class="ml-4 mt-2 mr-4 w-1 justify-center">
                        @for (stop of tripDetails.stops; track $index) {
                            <article [class]="tripDetails.stops.length === $index + 1 ? '' : 'h-20'" [ngStyle]="getLineColor($index)">
                                <div [class]="'text-white h-6 w-6 rotate-180 rounded-[50%] ml-[-0.6rem]'" [ngStyle]="getStopColor($index)">
                                    <div class="h-3 w-3 rounded-[50%] bg-white ml-1.5 mt-1.5 absolute"></div>
                                </div>
                            </article>
                        }
                    </div>
                    <div class="ml-4 justify-center font-semibold text-base w-full pr-2">
                        @for (stop of tripDetails.stops; track $index) {
                            <article [id]="'stop' + stop.id" class="flex h-10 items-center mb-10">
                                <label class="mr-4 flex-auto">{{ stop.name }}</label>
                                <div class="flex-auto"></div>
                                @if (stop.passengersIn > 0 || stop.prmIn > 0) {
                                    <article class="bg-secondary-green-light w-15 rounded ps-2 pe-2 mr-2 cursor-pointer" (click)="showViewPickUpsEventEmitter.emit(stop.id)">
                                    @if (stop.passengersIn > 0) {
                                        <div class="flex justify-center items-center">
                                            + {{ stop.passengersIn }}
                                            <img [src]="images.pax" alt="pax" class="h-4 w-4" />
                                        </div>
                                    }
                                    @if (stop.prmIn > 0) {
                                        <div class="flex justify-center items-center">
                                            + {{ stop.prmIn }}
                                            <img [src]="images.prm" alt="prm" class="h-4 w-4" />
                                        </div>
                                    }
                                    </article>
                                }
                                @if (stop.passengersOut > 0 || stop.prmOut > 0) {
                                    <article class="bg-secondary-orange-light w-15 rounded ps-2 pe-2 mr-2 cursor-pointer" (click)="showViewDropOffsEventEmitter.emit(stop.id)">
                                    @if (stop.passengersOut > 0) {
                                        <div class="flex justify-center items-center">
                                            - {{ stop.passengersOut }}
                                            <img [src]="images.pax" alt="prm" class="h-4 w-4" />
                                        </div>
                                    }
                                    @if (stop.prmOut > 0) {
                                        <div class="flex justify-center items-center">
                                            - {{ stop.prmOut }}
                                            <img [src]="images.prm" alt="prm" class="h-4 w-4" />
                                        </div>
                                    }
                                    </article>
                                }
                                @if (stop.unexpectedPassengers !== 0) {
                                    <article class="bg-primary-green-2 w-12.5 rounded ps-2 pe-2 mr-2">
                                        <div class="flex justify-center items-center">
                                            + {{ stop.unexpectedPassengers }}
                                        </div>
                                    </article>
                                }
                                @if (stop.changeover) {
                                    <article class="bg-primary-purple-light-2 w-12.5 rounded ps-2 pe-2 pt-1 pb-1 mr-2  cursor-pointer" (click)="showViewChangeOversEventEmitter.emit(stop.id)">
                                        <div class="flex justify-center items-center">
                                            <img [src]="images.changeover" alt="changeover" class="h-4 w-4" />
                                        </div>
                                    </article>
                                }
                            </article>
                        }
                    </div>
                </div>
            </article>
            <article>
                <div class="h-px bg-neutrals-grey-02 ml-4 mr-4"></div>
            </article>
            <article>
                <div class="text-right pt-4 mr-4">
                    @if (tripDetails.creatorName || tripDetails.createdAt) {
                        <p class="changelog text-primary-purple-light font-light text-sm">{{ literalService.get('created', true) }}
                            @if (tripDetails.creatorName) {
                                <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ tripDetails.creatorName }}</span>
                            }
                                {{ literalService.get('at') }} {{ utilsService.convertDate(tripDetails.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
                        </p>
                    }
                    @if (tripDetails.modifierName || tripDetails.lastModifiedAt) {
                        <p class="changelog text-primary-purple-light font-light text-sm">{{ literalService.get('lastModification', true) }}
                            @if (tripDetails.modifierName) {
                                <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ tripDetails.modifierName }}</span>
                            }
                                {{ literalService.get('at') }} {{ utilsService.convertDate(tripDetails.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm' }}
                        </p>
                    }
                </div>
            </article>
            @if (!isPositions && (selectedTrip.status === expeditionStatus.ONGOING || selectedTrip.status === expeditionStatus.CLOSED)) {
                <div class="drivenRouteInfoContainer absolute bottom-0 flex flex-row gap-2 bg-white rounded-lg p-2" [ngClass]="{'-right-18': !expandedDrivenRoute, '-right-59.75': expandedDrivenRoute}">
                    <div class="flex flex-col gap-2">
                        <div class="flex flex-row gap-2 items-center">
                            <div class="flex w-5 justify-center" [tooltip]="literalService.get('trips.showDrivenRoute', true)" [position]="TooltipPosition.ABOVE">
                                <img [src]="images.trips.drivenPosition" alt="drivenRoutePin" class="w-5 h-5" />
                            </div>
                            <div class="flex w-5 justify-center" [tooltip]="literalService.get('trips.showDrivenRoute', true)" [position]="TooltipPosition.ABOVE">
                                <app-checkbox
                                    class="[&_label]:ml-0 [&_label]:gap-0"
                                    [checked]="showDrivenRoute"
                                    (onChange)="onShowDrivenRouteChange($event)"
                                />
                            </div>
                        </div>
                        <div class="flex flex-row gap-2 cursor-pointer" (click)="expandedDrivenRoute = !expandedDrivenRoute">
                            <div class="flex w-5 justify-center">
                                <img [src]="images.info" alt="drivenRouteInfo" class="w-5 h-5" />
                            </div>
                            <div class="flex w-5 justify-center">
                                <img [src]="images.arrowRight" alt="drivenRouteExpand" class="w-5 h-5" [ngClass]="{'actionRotateArrowOpen': !expandedDrivenRoute, 'actionRotateArrowClose': expandedDrivenRoute}" />
                            </div>
                        </div>
                    </div>
                    @if (expandedDrivenRoute) {
                        <div class="flex flex-row gap-2">
                            <article class="flex flex-col px-2 max-w-20 leading-4 text-sm justify-center">
                                {{ literalService.get('trips.drivenDistance', true) }}
                                <span class="font-semibold">{{ tripDetails.drivenKms && tripDetails.drivenKms > 0 ? tripDetails.drivenKms : '-' }} km</span>
                            </article>
                            <article class="flex flex-col px-2 max-w-20 leading-4 text-sm justify-center">
                                {{ literalService.get('trips.similarity', true) }}
                                <span class="font-semibold">{{ tripDetails.similarity && tripDetails.similarity > 0 ? tripDetails.similarity : '-' }}%</span>
                            </article>
                        </div>
                    }
                </div>
            }
        </div>
    }
</section>
